/* eslint-disable */
import dicts from './example'

// 党员奖惩情况-表单
export const branchMemberRecordForm = {
    attrs: {
        labelWidth: '180px',
        'label-position': 'left',
        rules: {
            // userUid: [
            //     {
            //         required: true,
            //         message: '请选择',
            //         trigger: 'change',
            //     },
            // ],
            // honourName: [
            //     {
            //         required: true,
            //         message: '请输入',
            //         trigger: 'blur',
            //     },
            // ],
            // honourLevel: [
            //     {
            //         required: true,
            //         message: '请选择',
            //         trigger: 'change',
            //     },
            // ],
            // punishment: [
            //     {
            //         required: true,
            //         message: '请选择',
            //         trigger: 'change',
            //     },
            // ],
            // punishmentInfo: [
            //     {
            //         required: true,
            //         message: '请输入',
            //         trigger: 'blur',
            //     },
            // ],
            // punishmentLevel: [
            //     {
            //         required: true,
            //         message: '请选择',
            //         trigger: 'change',
            //     },
            // ],
        },
    },
    items: [
        {
            type: 'select-remote-input',
            showType: 'select',
            label: '党员姓名',
            prop: 'userId',
            filterable: true,
            remote: true,
            paramsKey: 'name',
            remoteAction: 'getMemberListApi',
            labelName: 'name',
            valueName: 'id',
            maxlength: 20,
            showWordLimit: true,
            filterable: true,
            clearable: true
        },
        {
            label: '表彰、奖励名称',
            prop: 'honourName',
            maxlength: 100,
            showWordLimit: true,
            clearable: true,
        },
        {
            type: 'select',
            label: '表彰奖励级别',
            prop: 'honourLevel',
            options: dicts.honourLevel(),
        },
        {
            type: 'select',
            label: '惩处情况',
            prop: 'punishment',
            options: dicts.isHas(),
        },
        {
            label: '惩处详情',
            prop: 'punishmentInfo',
            maxlength: 100,
            showWordLimit: true,
            clearable: true,
        },
        {
            type: 'select',
            label: '惩处级别',
            prop: 'punishmentLevel',
            options: dicts.honourLevel(),
        },
    ],
}

// 党员奖惩情况-表格
export const branchMemberRecordCols = [
    {
        title: '党员姓名',
        key: 'name',
        tooltip: true,
        width: 160,
    },
    {
        title: '表彰奖励名称',
        key: 'honourName',
        tooltip: true,
        minWidth: 240,
    },
    {
        title: '表彰奖励级别',
        slot: 'honourLevel',
        width: 200,
    },
    {
        title: '惩处情况',
        slot: 'punishment',
        width: 200,
    },
     {
        title: '惩处详情',
        key: 'punishmentInfo',
        tooltip: true,
        width: 240,
    },
    {
        title: '惩处级别',
        slot: 'punishmentLevel',
        width: 200,
    },
    {
        title: '操作',
        slot: 'operation',
        width: 160,
        fixed: 'right',
        align: 'center'
    }
]
